















































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class BaseDialog extends Vue {
  @Prop({ default: '' })
  public title!: string;

  @Prop({ default: '' })
  public content!: string;

  @Prop({ default: 'Remove' })
  public confirmButtonText!: string;

  @Prop({ default: true })
  public confirmButton!: boolean;

  @Prop({ default: 'Cancel' })
  public cancelButtonText!: string;

  @Prop({ default: true })
  public cancelButton!: boolean;

  @Prop({ default: true })
  public showCloseButton!: boolean;

  @Prop({ type: Boolean, default: false })
  public isUnsavedChangesConfirmationDialog!: boolean;

  public mounted() {
    if (this.isUnsavedChangesConfirmationDialog) {
      this.$store.dispatch(
        'unsavedChangesGuard/setUnsavedChangesDialogActive',
        true,
      );
    }
  }

  public beforeDestroy(): void {
    if (this.isUnsavedChangesConfirmationDialog) {
      // Dispatch the corresponding action to set the flag to false when the dialog is closed.
      this.$store.dispatch(
        'unsavedChangesGuard/setUnsavedChangesDialogActive',
        false,
      );
    }
  }
}
